import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/pic.png';
const _withScopeId = n => (_pushScopeId("data-v-3ff1749d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "header-top"
};
const _hoisted_3 = {
  class: "top"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "成都百分百文化传播有限公司", -1));
const _hoisted_5 = {
  key: 0,
  class: "header-right"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_7 = {
  key: 1,
  class: "header-right"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_9 = {
  class: "header-left"
};
import { RouterLink } from "vue-router";
import { reactive, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      account: null
    });
    onMounted(() => {
      var _JSON$parse;
      const User = window.localStorage.getItem('user');
      data.account = (_JSON$parse = JSON.parse(User)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.account;
    });
    const quit = () => {
      window.localStorage.clear();
      location.reload();
    };
    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", null, [data.account ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(data.account), 1), _createTextVNode(" ｜ "), _createElementVNode("span", {
        style: {
          "color": "#ce29aa"
        },
        onClick: quit
      }, "退出")])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createVNode(_unref(RouterLink), {
        to: "/login",
        style: {
          "color": "#fff"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("登录")]),
        _: 1
      }), _createTextVNode(" ｜ "), _createVNode(_unref(RouterLink), {
        to: "/register",
        style: {
          "color": "#fff"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("注册")]),
        _: 1
      })]))])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_tabs, null, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          title: "首页",
          to: "/"
        }), _createVNode(_component_van_tab, {
          title: "自审制度",
          to: "/system"
        }), _createVNode(_component_van_tab, {
          title: "充值中心",
          to: "/recharge"
        }), _createVNode(_component_van_tab, {
          title: "退款说明",
          to: "/refund"
        }), _createVNode(_component_van_tab, {
          title: "用户协议",
          to: "/agreement"
        }), _createVNode(_component_van_tab, {
          title: "隐私政策",
          to: "/privacy"
        }), _createVNode(_component_van_tab, {
          title: "未成年人隐私保护政策",
          to: "/minority"
        }), _createVNode(_component_van_tab, {
          title: "纠纷处理",
          to: "/dispute"
        })]),
        _: 1
      })])])]);
    };
  }
});